/**
 * Plugin to register Cassie Material Design components
 * This ensures proper integration with Vuetify and styles
 */
import Vue from 'vue'
import CassieComponents from '@syrenis/cassie-material-design'
import vuetify from './vuetify.js'

// Import the component library's global styles
import '@syrenis/cassie-material-design/dist/main.css'

/**
 * Install the component library with the Vuetify instance
 * This is required for the components to work correctly with Vuetify
 */
Vue.use(CassieComponents, { vuetify })

export default CassieComponents
